// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DCSBoard_wrapper__LcxLn"};